export default "__VITE_ASSET__CDQKG89b__"